import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const UNVERIFIED_ASSET_QUERY_KEY = 'unverified-asset-detail';

export const useInvalidateUnverifiedAsset = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async ({ applicationId }: { applicationId: string }) => {
      await queryClient.invalidateQueries({
        queryKey: [UNVERIFIED_ASSET_QUERY_KEY, applicationId],
        exact: false,
      });
    },
    [queryClient],
  );
};
